module.exports = __webpack_public_path__ + "img/3.fbe91f88.jpg";